<template>
  <div class="page_all">
    <div class="return_link">
      <router-link to="/setting">＞ 設定</router-link>
    </div>
    <div class="page_header">
      <div class="header_title">
        <div class="title">認証コード</div>
        <div class="message">
          <div class="error">{{ message }}</div>
        </div>
      </div>
    </div>
    <div class="page_main">
      <table class="tbl_main">
        <thead>
          <tr>
            <th class="th_head">認証コード</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="td_content_top">
              <div v-if="this.$store.getters.getStateCompanyCognitoUserStatus != 'FORCE_CHANGE_PASSWORD'" class="title_name">認証コードの変更</div>
              <div v-else class="title_name">仮認証コードから正式認証コードへの変更</div>
            </td>
          </tr>
          <tr>
            <td class="td_content_middle">
              <div v-if="this.$store.getters.getStateCompanyCognitoUserStatus != 'FORCE_CHANGE_PASSWORD'" class="index_name">現在の認証コード</div>
              <div v-else class="index_name">仮認証コード</div>
              <div>
                <input v-model.trim="$v.currentPassword.$model" type="password" class="password_text"/>
              </div>
              <div class="message">
                <div v-if="$v.currentPassword.$dirty">
                  <div class="error" v-if="!$v.currentPassword.required">必須入力です。</div>
                  <div class="error" v-if="!$v.currentPassword.minLength">認証コードの長さは最低{{ $v.currentPassword.$params.minLength.min }}文字以上です。</div>
                  <div class="error" v-if="!$v.currentPassword.customPassword">半角英数字記号で入力してください。</div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="td_content_middle">
              <div class="index_name">新しい認証コード</div>
              <div>
                <input v-model.trim="$v.newPassword.$model" type="password" class="password_text"/>
              </div>
              <div class="message">
                <div v-if="$v.newPassword.$dirty">
                  <div class="error" v-if="!$v.newPassword.required">必須入力です。</div>
                  <div class="error" v-if="!$v.newPassword.minLength">認証コードの長さは最低{{ $v.newPassword.$params.minLength.min }}文字以上です。</div>
                  <div class="error" v-if="!$v.newPassword.customPassword">半角英数字記号で入力してください。</div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="td_content_middle">
              <div class="index_name">新しい認証コード（確認）</div>
              <div>
                <input v-model.trim="$v.confirmPassword.$model" type="password" class="password_text"/>
              </div>
              <div class="message">
                <div v-if="$v.confirmPassword.$dirty">
                  <div class="error" v-if="!$v.confirmPassword.required">必須入力です。</div>
                  <div class="error" v-if="!$v.confirmPassword.minLength">認証コードの長さは最低{{ $v.confirmPassword.$params.minLength.min }}文字以上です。</div>
                  <div class="error" v-if="!$v.confirmPassword.customPassword">半角英数字記号で入力してください。</div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="td_content_bottom">
              <div v-if="this.$store.getters.getStateCompanyCognitoUserStatus != 'FORCE_CHANGE_PASSWORD'"><button :disabled="$v.$invalid" class="btn_general" v-on:click="passwordChange()">登録</button></div>
              <div v-else><button :disabled="$v.$invalid" class="btn_general" v-on:click="passwordAuthChallenge()">登録</button></div>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- 以下モーダルウィンドウ -->
      <modal v-if="showModal" @close="closeModal">
        <div class="modal_main">
          <table class="tbl_modal">
            <tbody>
              <tr class="tr_modal">
                <div class="modal_comment">認証コードを変更しました。</div>
              </tr>
              <tr class="tr_modal">
                <div class="modal_btn_close">
                  <div></div>
                  <div>
                    <button class="btn_general" @click="closeModal">閉じる</button>
                  </div>
                </div>
              </tr>
            </tbody>
          </table>
        </div>
      </modal>
      <!-- ここまでモーダルウィンドウ -->
    </div>
  </div>
</template>

<script>
import { required, minLength, } from 'vuelidate/lib/validators'
// モーダルウィンドウ
import modal from '@/components/PasswordModal.vue'

const customPassword = (password) => {
  // 未入力時はフォーマット確認の判定をおこなわない
  if (!password || typeof password !== "string" || password === "") {
    return true;
  }
  // 文字数判定もおこなわない
  return !!password.match(/^[0-9A-Za-z+=\-^$*.[\]{}()?"!@#%&/\\,><':;|_~`]+$/);
};

export default {
  components: {
    modal
  },
  data: function() {
    return {
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
      // メッセージ
      message: "",
      // モーダル変数
      showModal: false
    }
  },
  mounted() {
    console.log(this.$store.getters.getStateChargeId)

    console.log(this.$store.getters.getStateCompanyCognitoUserStatus)
    console.log(this.$store.getters.getStateCompanyId)
    console.log(this.$store.getters.getStateCompanyFlg)
    if (!this.$store.getters.getStateIsLogin) {
      this.$store.commit("logout");
      this.$router.push({ name: 'login' });
    }
  },
  methods: {
    async passwordChange() {
      // パスワードの一致確認
      if (this.newPassword != this.confirmPassword) {
        this.message = "パスワードと確認用パスワードが異なります。"
        return
      }

      try {
        const response = await this.$axios.post(process.env.VUE_APP_API_BASEURL + 'password/change', {
          user_name: this.$store.getters.getStateChargeId,
          current_password: this.currentPassword,
          new_password: this.newPassword,
          municipality_key: this.$store.getters.getStateMunicipalityKey,
          company_id: this.$store.getters.getStateCompanyId,
          company_flg: this.$store.getters.getStateCompanyFlg
        })
        console.log(response)
        // トークン情報を更新
        // this.$store.commit('setStateIdToken', response.data.IdToken)
        // this.$store.commit('setStateAccessToken', response.data.AccessToken)
        // this.$store.commit('setStateRefreshToken', response.data.RefreshToken)
        // フィールド初期化
        this.initialize()
        // ダイアログ
        this.openModal()
      } catch (err) {
        this.message = err.response.data.errorMessage
      }
    },
    async passwordAuthChallenge() {
      // パスワードの一致確認
      if (this.newPassword != this.confirmPassword) {
        this.message = "パスワードと確認用パスワードが異なります。"
        return
      }

      try {
        const response = await this.$axios.post(process.env.VUE_APP_API_BASEURL + 'password/challenge', {
          user_name: this.$store.getters.getStateChargeId,
          current_password: this.currentPassword,
          new_password: this.newPassword,
          municipality_key: this.$store.getters.getStateMunicipalityKey,
          company_id: this.$store.getters.getStateCompanyId,
          company_flg: this.$store.getters.getStateCompanyFlg
        })
        console.log(response)


        // 担当者情報取得 for company_cognito_user_status
        const info = await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'charge/info', {
          params: {
            charge_email: this.$store.getters.getStateChargeId
          }
        })

        this.$store.commit('setStateCompanyCognitoUserStatus', info.data[0].company_cognito_user_status)

        // トークン情報を更新
        // this.$store.commit('setStateIdToken', response.data.IdToken)
        // this.$store.commit('setStateAccessToken', response.data.AccessToken)
        // this.$store.commit('setStateRefreshToken', response.data.RefreshToken)
        // フィールド初期化
        this.initialize()
        // ダイアログ
        this.openModal()
        // 認証済みとし、地域画面へ遷移
        // this.$store.commit('setStateIsAuthenticated', true)
        // this.$router.push({ name: 'areaList' })
      } catch (err) {
        this.message = err.response.data.errorMessage
      }
    },
    initialize: function() {
      // フィールド初期化
      this.currentPassword = ""
      this.newPassword = ""
      this.confirmPassword = ""
      this.message = ""
      this.$v.currentPassword.$reset()
      this.$v.newPassword.$reset()
      this.$v.confirmPassword.$reset()
    },
    openModal: function() {
      this.showModal = true
    },
    closeModal: function() {
      this.showModal = false
    },
  },
  validations: {
    currentPassword: {
      required,
      minLength: minLength(8),
      customPassword,
    },
    newPassword: {
      required,
      minLength: minLength(8),
      customPassword,
    },
    confirmPassword: {
      required,
      minLength: minLength(8),
      customPassword,
    }
  }
}
</script>

<style scoped>
table th.th_head {
  width: 700px;
  text-align: center;
}
table tr {
  border: none;
}
table td.td_content_top {
  text-align: left;
  border: none;
  padding: 20px 0px 20px 20px;
  font-size: 15px;
}
table td.td_content_middle {
  text-align: left;
  border: none;
  padding: 0px 0px 0px 20px;
}
table td.td_content_bottom {
  text-align: center;
  border: none;
  padding: 0px 0px 20px 10px;
}
.index_name {
  padding: 0px 0px 5px 0px;
}
.password_text {
  width: 200px;
}

/* モーダル画面 */
.tr_modal {
  border: none;
}
.modal_main {
  width: 380px;
}
.modal_comment {
  text-align: center;
  padding: 20px;
}
.tbl_modal {
  width: 380px;
  border: 1px #666666 solid;
  border-collapse: collapse;
  margin: 0 auto;
}
.modal_btn_close {
  display: flex;
  justify-content: space-between;
  border-top: 1px #666666 solid;
  background-color: #F7F2E0;
  padding: 3px 5px 3px 0px;
}
</style>